import { render, staticRenderFns } from "./WeServeOrder.vue?vue&type=template&id=c8d79c9e&scoped=true&"
import script from "./WeServeOrder.vue?vue&type=script&lang=js&"
export * from "./WeServeOrder.vue?vue&type=script&lang=js&"
import style0 from "./WeServeOrder.vue?vue&type=style&index=0&id=c8d79c9e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d79c9e",
  null
  
)

export default component.exports